import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, TextArea, Anchor, TextInput, MaskedInput, Box, Select, SelectMultiple, Text } from 'grommet';
import { FormClose, AddCircle, Close } from 'grommet-icons';

import { Placeholder, ErrorForm } from '../../../../components';
import { TitleField, DescriptionField, CalendarDropButton } from '../../../../components/form';
import { TitleDetail } from '../../../../components/detail';

import { getCity } from '../../../../actions/select-options';
import { searchAmendments } from '../../actions/form-search';
import { update, create, hideFormManagerLayer } from '../../actions/form-manager';
import { changeValues } from '../../../../actions/form';

import visibleWidth from '../../../../constants/layer-width';

import selectYearOptions from '../../../../constants/select-year-options';
import selectAmendmentResourceOriginOptions from '../../../../constants/select-amendment-resource-origin-options';
import { productSystemEnum } from '../../../../constants/product-system';

function FormCreate(props) {
  const [requesterName, setRequester] = useState('');
  const [beneficiaryName, setBeneficiary] = useState('');

  const {
    userLogged,

    stageAmendmentsOptions,
    departmentOptions,
    cityOptions,

    id,
    stageId,
    secretaryId,
    value,
    object,
    observation,
    paymentDate,
    year,
    resourceOrigin,
    requester,
    beneficiary,
    region,
    regionOptions,

    getServerPresponseError,
    watingServerResponse,

    toggleLayer,
    loadingPostForm,
    postDataError,

    changeValues,
    hideFormManagerLayer,
  } = props;

  const onSearchCities = useCallback(text => {
    if (text.length < 3) return;

    const { getCity } = props;
    getCity({ name: text });
  }, [props]);

  const callbackPostSuccess = useCallback(() => {
    const {
      searchAmendments,
      hideFormManagerLayer,
    } = props;

    searchAmendments();
    hideFormManagerLayer();
  }, [props]);

  const handlePost = useCallback(formParams => {
    const { isEditing, create, update } = props;

    if(isEditing && formParams.id) {
      update({ formParams });
    }
    else {
      create({
        formParams,
        callbackSuccess: callbackPostSuccess
      });
    }
  }, [callbackPostSuccess, props]);


  if(!toggleLayer || toggleLayer !== 'manager')
    return null;

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Layer
          responsive={false}
          full='vertical'
          position='left'
          onClickOutside={hideFormManagerLayer}
          onEsc={hideFormManagerLayer}
        >
          <Box
            fill='vertical'
            width={visibleWidth[size]}
            pad={{ top: 'large', bottom: 'xsmall' }}
            overflow='auto'
            flex
          >
            {watingServerResponse && !id && !getServerPresponseError ? (
              <Placeholder
                title='Carregando...'
                message='Aguarde que estamos preparando as coisas :)'
              />
            ) : null}

            {getServerPresponseError ? (
              <Placeholder
                title='Ops! Algo deu errado :('
                message='Estamos constrangidos por isso.'
                button={{
                  label: 'Fechar',
                  action: hideFormManagerLayer,
                }}
              />
            ) : null}

            {!getServerPresponseError && (id || !watingServerResponse) ? (
              <>
                <Box
                  direction='row'
                  justify='between'
                  align='baseline'
                  margin={{ horizontal: 'large' }}
                >
                  <TitleDetail
                    value={id ? 'Editar emenda' : 'Nova emenda'}
                  />

                  <Button
                    plain
                    title='Fechar'
                    icon={<FormClose />}
                    onClick={hideFormManagerLayer}
                  />
                </Box>


                <Box flex overflow='auto'>
                  {/* Origin recurso */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    direction={ size === 'small' ? 'column' : 'row' }
                    align='stretch'
                    flex={{ shrink: 0 }}
                    gap='small'
                  >
                    <Box
                      width={ size === 'small' ? '100vw' : '40vw' }
                      gap='xxsmall'
                    >
                      <TitleField
                        text='Origem do recurso' required
                      />

                      {userLogged.client?.productId === productSystemEnum.DEPUTADO && <DescriptionField
                        text='Esse recurso está vindo de algum órgão ou é um pedido de um vereador ou prefeito?'
                      />}
                    </Box>

                    <Box
                      width={ size === 'small' ? '100vw' : '50vw' }
                    >
                      <Select
                        options={
                          selectAmendmentResourceOriginOptions.filter(option =>
                            option.productSystems.includes(userLogged.client?.productId)
                          )
                        }
                        disabled={ userLogged.client?.productId !== productSystemEnum.DEPUTADO }
                        value={resourceOrigin ?? ''}
                        labelKey='name'
                        valueKey={{ key: 'id', reduce: true }}
                        emptySearchMessage='Selecione uma opção'
                        placeholder='Selecione uma opção'
                        onChange={({ value: nextValue }) =>
                          changeValues({ fieldName: 'resourceOrigin', value: nextValue }, 'formChangeValues')
                        }
                      />

                      <ErrorForm errorsList={postDataError.errors} fieldName='resourceOrigin' />
                    </Box>
                  </Box>


                  {/* Secretaria */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <Box direction='row' align='center' gap='xsmall'>
                      <TitleField text='Secretaria' />

                      {(secretaryId || secretaryId > 0) && (
                        <Anchor
                          size='small'
                          label='limpar'
                          onClick={() =>
                            changeValues({ fieldName: 'secretaryId', value: null }, 'formChangeValues')
                          }
                        />
                      )}
                    </Box>

                    <Select
                      options={departmentOptions}
                      value={secretaryId ?? ''}
                      labelKey='name'
                      valueKey={{ key: 'id', reduce: true }}
                      emptySearchMessage='Selecione uma opção'
                      placeholder='Selecione a secretaria da emenda'
                      onChange={({ value: nextValue }) =>
                        changeValues({ fieldName: 'secretaryId', value: nextValue }, 'formChangeValues')
                      }
                    />

                    <ErrorForm errorsList={postDataError.errors} fieldName='secretaryId' />
                  </Box>


                  {/* Estágio */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <TitleField text='Estágio' required />

                    <Select
                      options={stageAmendmentsOptions}
                      value={stageId ?? ''}
                      labelKey='name'
                      valueKey={{ key: 'id', reduce: true }}
                      emptySearchMessage='Selecione uma opção'
                      placeholder='Selecione o estágio da emenda'
                      onChange={({ value: nextValue }) =>
                        changeValues({ fieldName: 'stageId', value: nextValue }, 'formChangeValues')
                      }
                    />

                    <ErrorForm errorsList={postDataError.errors} fieldName='stageId' />
                  </Box>

                  <Box
                    border={{ color: 'light-3', side: 'bottom' }}
                    margin={{ top: 'medium', bottom: 'medium' }}
                  />


                  {/* Objeto */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <TitleField text='Objeto' required />

                    <TextInput
                      maxLength={256}
                      value={object ?? ''}
                      placeholder='Ex. Custeio, Obras, Infraestrutura, etc.'
                      onChange={event =>
                        changeValues({ fieldName: 'object', value: event.target.value }, 'formChangeValues')
                      }
                    />

                    <ErrorForm errorsList={postDataError.errors} fieldName='object' />
                  </Box>


                  {/* Ano */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    direction={ size === 'small' ? 'column' : 'row' }
                    align='stretch'
                    flex={{ shrink: 0 }}
                    gap='small'
                  >
                    <Box
                      width={ size === 'small' ? '100vw' : '50vw' }
                      gap='xxsmall'
                    >
                      <TitleField
                        text='Ano da emenda' required
                      />

                      <DescriptionField
                        text='Qual o ano dessa emenda?'
                      />
                    </Box>

                    <Box
                      width={ size === 'small' ? '100vw' : '50vw' }
                    >
                      <Select
                        options={selectYearOptions}
                        value={year ?? ''}
                        labelKey='name'
                        valueKey={{ key: 'id', reduce: true }}
                        emptySearchMessage='Selecione uma opção'
                        placeholder='Selecione o ano da emenda'
                        onChange={({ value: nextValue }) =>
                          changeValues({ fieldName: 'year', value: nextValue }, 'formChangeValues')
                        }
                      />

                      <ErrorForm errorsList={postDataError.errors} fieldName='year' />
                    </Box>
                  </Box>


                  {/* Valor */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    direction={ size === 'small' ? 'column' : 'row' }
                    align='stretch'
                    flex={{ shrink: 0 }}
                    gap='small'
                  >
                    <Box
                      width={ size === 'small' ? '100vw' : '50vw' }
                      gap='xxsmall'
                    >
                      <TitleField
                        text='Valor emenda' required
                      />

                      <DescriptionField
                        text='Qual o valor dessa emenda?'
                      />
                    </Box>

                    <Box
                      width={ size === 'small' ? '100vw' : '50vw' }
                    >
                      <MaskedInput
                        value={value ?? ''}
                        placeholder='R$ 000,00'
                        reverse={true}
                        onChange={event =>
                          changeValues({ fieldName: 'value', value: event.target.value }, 'formChangeValues')
                        }
                        mask={[
                          { fixed: 'R$ ' },
                          { regexp: /^[0-9]{1,8}$/ },
                          { fixed: ',' },
                          { regexp: /^[0-9]{1,2}$/ },
                        ]}
                      />

                      <ErrorForm errorsList={postDataError.errors} fieldName='value' />
                    </Box>
                  </Box>


                  {/* Pagamento */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    direction={ size === 'small' ? 'column' : 'row' }
                    align='stretch'
                    flex={{ shrink: 0 }}
                    gap='small'
                  >
                    <Box
                      width={ size === 'small' ? '100vw' : '50vw' }
                      gap='xxsmall'
                    >
                      <TitleField
                        text='Data de pagamento'
                      />

                      <DescriptionField
                        text='Esse recurso foi pago? Informe qual a data...'
                      />
                    </Box>

                    <Box
                      width={ size === 'small' ? '100vw' : '50vw' }
                    >
                      <CalendarDropButton
                        date={paymentDate ?? ''}
                        title='Informe a data prevista para o reembolso dessa despesa'
                        onSelect={(selectedDate) =>
                          changeValues({ fieldName: 'paymentDate', value: selectedDate }, 'formChangeValues')
                        }
                      />

                      <ErrorForm errorsList={postDataError.errors} fieldName='paymentDate' />
                    </Box>
                  </Box>

                  <Box
                    border={{ color: 'light-3', side: 'bottom' }}
                    margin={{ top: 'medium', bottom: 'medium' }}
                  />


                  {/* Solicitante */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    direction={ size === 'small' ? 'column' : 'row' }
                    align='stretch'
                    flex={{ shrink: 0 }}
                    gap='small'
                  >
                    <Box
                      width={ size === 'small' ? '100vw' : '40vw' }
                      gap='xxsmall'
                    >
                      <TitleField
                        text='Solicitante(s)'
                      />

                      <DescriptionField
                        text='Você pode informar um ou mais nomes...'
                      />
                    </Box>

                    <Box
                      width={ size === 'small' ? '100vw' : '60vw' }
                    >
                      <Box
                        direction='row'
                        round='xsmall'
                        border={{ color: 'light-4' }}
                        background='white'
                      >
                        <TextInput
                          plain
                          maxLength={50}
                          value={requesterName ?? ''}
                          placeholder='Informe o nome e clique em adicionar.'
                          onChange={event => {
                            const { value: newValue } = event.target;

                            setRequester(newValue);
                          }}
                        />

                        <Button
                          icon={<AddCircle color='neutral-1' />}
                          disabled={!requesterName}
                          onClick={() => {
                            changeValues(
                              { fieldName: 'requester', value: requesterName }, 'formAddValues'
                            );

                            setRequester('');
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>

                  {/* Solicitante lista */}
                  {requester && requester.length > 0 ? (
                    <Box
                      margin={{
                        vertical: 'small',
                        horizontal: 'large'
                      }}
                      flex={{ shrink: 0 }}
                      border={{ color: 'light-4' }}
                      round='small'
                    >
                      {requester.map((item, index) => (
                        <Box
                          key={index}
                          align='center'
                          direction='row'
                          justify='between'
                          pad={{ horizontal: 'small' }}
                        >
                          <Text size='small' color='dark-2'>{item}</Text>

                          <Anchor
                            icon={<Close size='small' />}
                            color='status-critical'
                            title='Remover'
                            onClick={() =>
                              changeValues(
                                { fieldName: 'requester', value: item }, 'formRemoveValues'
                              )
                            }
                          />
                        </Box>))
                      }
                    </Box>
                  ) : null}


                  {/* Beneficiário */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    direction={ size === 'small' ? 'column' : 'row' }
                    align='stretch'
                    flex={{ shrink: 0 }}
                    gap='small'
                  >
                    <Box
                      width={ size === 'small' ? '100vw' : '40vw' }
                      gap='xxsmall'
                    >
                      <TitleField
                        text='Beneficiário(s)'
                      />

                      <DescriptionField
                        text='Você pode informar um ou mais nomes, entidades, etc...'
                      />
                    </Box>

                    <Box
                      width={ size === 'small' ? '100vw' : '60vw' }
                    >
                      <Box
                        direction='row'
                        round='xsmall'
                        border={{ color: 'light-4' }}
                        background='white'
                      >
                        <TextInput
                          plain
                          maxLength={50}
                          value={beneficiaryName ?? ''}
                          placeholder='Informe o nome e clique em adicionar.'
                          onChange={event => {
                            const { value: newValue } = event.target;

                            setBeneficiary(newValue);
                          }}
                        />

                        <Button
                          icon={<AddCircle color='neutral-1' />}
                          disabled={!beneficiaryName}
                          onClick={() => {
                            changeValues(
                              { fieldName: 'beneficiary', value: beneficiaryName }, 'formAddValues'
                            );

                            setBeneficiary('');
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>

                  {/* Beneficiário lista */}
                  {beneficiary && beneficiary.length > 0 ? (
                    <Box
                      margin={{
                        vertical: 'small',
                        horizontal: 'large'
                      }}
                      flex={{ shrink: 0 }}
                      border={{ color: 'light-4' }}
                      round='small'
                    >
                      {beneficiary.map((item, index) => (
                        <Box
                          key={index}
                          align='center'
                          direction='row'
                          justify='between'
                          pad={{ horizontal: 'small' }}
                        >
                          <Text size='small' color='dark-2'>{item}</Text>

                          <Anchor
                            icon={<Close size='small' />}
                            color='status-critical'
                            title='Remover'
                            onClick={() =>
                              changeValues(
                                { fieldName: 'beneficiary', value: item }, 'formRemoveValues'
                              )
                            }
                          />
                        </Box>))
                      }
                    </Box>
                  ) : null}


                  {/* Cidade */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    direction={ size === 'small' ? 'column' : 'row' }
                    align='stretch'
                    flex={{ shrink: 0 }}
                    gap='small'
                  >
                    <Box
                      width={ size === 'small' ? '100vw' : '40vw' }
                      gap='xxsmall'
                    >
                      <TitleField
                        text='Cidade' required
                      />

                      <DescriptionField
                        text='Informe uma ou mais cidades...'
                      />
                    </Box>

                    <Box
                      width={ size === 'small' ? '100vw' : '60vw' }
                    >
                      <SelectMultiple
                        searchPlaceholder='Digite para buscar...'
                        emptySearchMessage=''
                        options={[ ...cityOptions, ...regionOptions ]}
                        value={region ?? []}
                        labelKey='name'
                        valueKey={{ key: 'id', reduce: true }}
                        dropHeight='medium'
                        placeholder='Selecione a cidade'
                        sortSelectedOnClose
                        messages={{
                          clearAll: 'Limpar',
                          selectAll: 'Selecionar todos',
                          selected: '{selected} selecionado(s)',
                          selectedOfTotal: '{selected} de {total} selecionado(s)',
                        }}
                        onSearch={ text => onSearchCities(text) }
                        onChange={({ value: nextValue }) =>
                          changeValues({ fieldName: 'region', value: nextValue }, 'formChangeValues')
                        }
                        valueLabel={
                          region && region.length > 1 ? (
                            <Box pad='small'>
                              <Text>{`${region.length} selecionado(s)`}</Text>
                            </Box>
                          ) : null
                        }
                      >
                        {(option, index, options, { active, disabled, selected }) => {
                          return (
                            <Box
                              pad={{ horizontal: 'small', vertical: 'small' }}
                              gap='small'
                              direction='row'
                              align='baseline'
                            >
                              <Text
                                size='medium'
                                color='dark-1'
                                weight={selected ? 'bold' : 'normal'}
                              >
                                {option.name}
                              </Text>

                              <Text size='small' color='dark-6' weight={selected ? 'bold' : 'normal'}>
                                {option.stateAbbrev}
                              </Text>
                            </Box>
                          )
                        }}
                      </SelectMultiple>

                      <ErrorForm errorsList={postDataError.errors} fieldName='region' />
                    </Box>
                  </Box>

                  <Box
                    border={{ color: 'light-3', side: 'bottom' }}
                    margin={{ top: 'medium', bottom: 'medium' }}
                  />


                  {/* Observação */}
                  <Box
                    margin={{
                      vertical: 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <TitleField text='Observação' />

                    <TextArea
                      rows={4}
                      resize='vertical'
                      maxLength={512}
                      value={observation ?? ''}
                      onChange={event =>
                        changeValues({ fieldName: 'observation', value: event.target.value }, 'formChangeValues')
                      }
                    />

                    <ErrorForm errorsList={postDataError.errors} fieldName='observation' />
                  </Box>
                </Box>


                <Box
                  direction='row'
                  pad={{ vertical: 'medium' }}
                  justify='center'
                  align='center'
                  gap='small'
                >
                  <Box width='xsmall'>
                    <Anchor
                      color='dark-3'
                      label='Cancelar'
                      disabled={ loadingPostForm }
                      onClick={hideFormManagerLayer}
                    />
                  </Box>

                  <Box width='small'>
                    <Button
                      color='brand'
                      primary
                      label={ !loadingPostForm ? 'Salvar' : 'Salvando...' }
                      disabled={ loadingPostForm }
                      onClick={() =>
                        handlePost({
                          id,
                          stageId,
                          secretaryId,
                          value,
                          object,
                          observation,
                          paymentDate,
                          year,
                          resourceOrigin,
                          requester,
                          beneficiary,
                          region,
                        })
                      }
                    />
                  </Box>
                </Box>
              </>
            ) : null}
          </Box>
        </Layer>
      )}
    </ResponsiveContext.Consumer>
  );
}

const mapStateToProps = ({
  authReducer: { authenticated }, layerReducer, formCreateUpdateCopyGeneric, selectOptionsReducer,
 }) => ({
  userLogged: authenticated,

  departmentOptions: selectOptionsReducer.departmentOptions,
  stageAmendmentsOptions: selectOptionsReducer.stageAmendmentsOptions,
  cityOptions: selectOptionsReducer.cityOptions,

  id: formCreateUpdateCopyGeneric.id,
  stageId: formCreateUpdateCopyGeneric.stageId,
  secretaryId: formCreateUpdateCopyGeneric.secretaryId,
  value: formCreateUpdateCopyGeneric.value,
  object: formCreateUpdateCopyGeneric.object,
  observation: formCreateUpdateCopyGeneric.observation,
  paymentDate: formCreateUpdateCopyGeneric.paymentDate,
  year: formCreateUpdateCopyGeneric.year,
  resourceOrigin: formCreateUpdateCopyGeneric.resourceOrigin,
  requester: formCreateUpdateCopyGeneric.requester,
  beneficiary: formCreateUpdateCopyGeneric.beneficiary,
  region: formCreateUpdateCopyGeneric.region,
  regionOptions: formCreateUpdateCopyGeneric.regionOptions,

  isEditing: formCreateUpdateCopyGeneric.isEditing,

  watingServerResponse: formCreateUpdateCopyGeneric.watingServerResponse,
  getServerPresponseError: formCreateUpdateCopyGeneric.getServerPresponseError,

  loadingPostForm: formCreateUpdateCopyGeneric.loadingPostForm,
  postDataError: formCreateUpdateCopyGeneric.postDataError,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    update,
    create,
    changeValues,
    searchAmendments,
    getCity,
    hideFormManagerLayer,
  }, dispatch);

export const Create = connect(mapStateToProps, mapDispatchToProps)(FormCreate);
